import {useCarePractitionersByDoctorIdsQuery} from "@components/Booking/__generated__/care-practitioners-by-doctor-ids.type";
import {compact} from "lodash";
import {SpecialtyId} from "src/constants/specialtyIds";

import {useParsedBookingQuery} from "./bookingQuery";

/**
 * Reads the `doctor-id` query parameter and returns the corresponding doctor.
 */
export const useSelectedDoctor = () => {
  const {doctorId, specialtyId} = useParsedBookingQuery();

  const query = useCarePractitionersByDoctorIdsQuery({
    variables: {
      doctorIds: compact([doctorId]),
    },
    skip: specialtyId !== SpecialtyId.PRIMARY_CARE,
  });

  return query.data?.carePractitionersByDoctorIds?.[0];
};
